import { Fragment } from 'react';
import { Box, Grid, Typography, useTheme } from '@mui/material';

import MuiTable from 'components/MuiTable';
import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';
import useTableForm from './components/useTableForm';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const LEFSContents = (props: Props) => {
  const { palette } = useTheme();
  const { radioGroup, sumValues } = useTableForm(props);
  const { getValues } = props;

  const columns = [
    { fieldId: 'title', label: '' },
    { fieldId: '0', label: 'Vô cùng\nkhó khăn' },
    { fieldId: '1', label: 'Khá khó khăn (1)' },
    { fieldId: '2', label: 'Khó khăn nhiều (2)' },
    { fieldId: '3', label: 'Một chút \nkhó khăn (3)' },
    { fieldId: '4', label: 'Không gặp\nkhó khăn (4)' },
  ];

  const rows = [
    {
      id: 'lefs01',
      title:
        'a. Trong bất kỳ công việc thông thường, việc nhà hoặc hoạt\nđộng ở trường thông thường nào của bạn',
      ...radioGroup({
        key: 'lefs01',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs02',
      title:
        'b. Trong sở thích, hoạt động giải trí hoặc thể thao thông\nthường của bạn.',
      ...radioGroup({
        key: 'lefs02',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs03',
      title: 'c. Trong việc vào hoặc ra khỏi bồn tắm.',
      ...radioGroup({
        key: 'lefs03',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs04',
      title: 'd. Trong việc đi lại giữa các phòng.',
      ...radioGroup({
        key: 'lefs04',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs05',
      title: 'e. Trong việc mang giày hoặc tất.',
      ...radioGroup({
        key: 'lefs05',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs06',
      title: 'f. Trong việc ngồi xổm',
      ...radioGroup({
        key: 'lefs06',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs07',
      title:
        'g. Trong việc xách một vật, chẳng hạn như một túi hàng hóa\ntừ sàn nhà lên.',
      ...radioGroup({
        key: 'lefs07',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs08',
      title: 'h. Trong việc thực hiện các hoạt động nhẹ nhàng xung\nquanh nhà.',
      ...radioGroup({
        key: 'lefs08',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs09',
      title: 'i. Trong việc thực hiện các hoạt động nặng nề xung quanh \nnhà.',
      ...radioGroup({
        key: 'lefs09',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs10',
      title: 'j. Trong việc vào hoặc ra khỏi xe ô tô.',
      ...radioGroup({
        key: 'lefs10',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs11',
      title: 'k. Trong việc đi bộ 2 dãy nhà.',
      ...radioGroup({
        key: 'lefs11',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs12',
      title: 'l. Trong việc đi bộ 1 dặm',
      ...radioGroup({
        key: 'lefs12',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs13',
      title: 'm. Trong việc đi lên hoặc xuống 10 bậc thang (khoảng\n1 tầng).',
      ...radioGroup({
        key: 'lefs13',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs14',
      title: 'n. Trong việc đứng liên tục 1 giờ',
      ...radioGroup({
        key: 'lefs14',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs15',
      title: 'o. Trong việc ngồi liên tục 1 giờ',
      ...radioGroup({
        key: 'lefs15',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs16',
      title: 'p. Trong việc chạy trên mặt đường bằng phẳng.',
      ...radioGroup({
        key: 'lefs16',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs17',
      title: 'q. Trong việc chạy trên mặt  đường mấp mô',
      ...radioGroup({
        key: 'lefs17',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs18',
      title: 'r. Trong việc rẽ gấp khi chạy nhanh.',
      ...radioGroup({
        key: 'lefs18',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs19',
      title: 's. Trong việc nhảy lò cò',
      ...radioGroup({
        key: 'lefs19',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
    {
      id: 'lefs20',
      title: 't. Trong việc lăn mình trên giường.',
      ...radioGroup({
        key: 'lefs20',
        options: [0, 1, 2, 3, 4],
        sx: {
          paddingLeft: '10px',
        },
      }),
    },
  ];
  // console.log('잉', getValues('lefs02'));

  const watchSumValues = () => {
    const values = rows.map(({ id }) => {
      if (props.watch(`${id}`) === undefined) {
        return 0;
      } else {
        return Number(props.watch(`${id}`));
      }
    });
    return sumValues(values);
  };

  return (
    <Fragment>
      <SectionTitle title="Thang điểm chức năng chi dưới (LEFS)" />
      <Grid item xs={12}>
        <MuiTable columns={columns} rows={rows} />
      </Grid>
      <Grid item xs={12}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            Tổng : {watchSumValues()} / 80
          </Typography>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default LEFSContents;
